import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import * as AOS from 'aos';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import firebase from "firebase/app";
import "firebase/analytics";
import { Title } from '@angular/platform-browser';


declare let gtag;
declare var ga ;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'micro-sites';
  items: Observable<any[]>;
  constructor(router: Router, firestore: AngularFirestore, private titleService: Title) {
    const analytics = firebase.analytics();

    // this.items = firestore.collection('items').valueChanges();
    const navEndEvents = router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );
    navEndEvents.subscribe((event: NavigationEnd) => {
      console.log('the event should be fired');

      // environment.firebase['page_title'] =  window.location.hostname.split('.')[0]
      // console.log('dfddfdfd', window.location.hostname.split('.')[0]);
      // ga('set', 'title', window.location.hostname.split('.')[0]);
      analytics.logEvent(window.location.hostname.split('.')[0], {
        productName:  window.location.hostname.split('.')[0]
      });

    //   ga('send', 'event',  window.location.hostname.split('.')[0]);
    //   gtag('event', window.location.hostname.split('.')[0] , {
    //     productName: window.location.hostname.split('.')[0]
    // });


    /// change the title of the page
    this.titleService.setTitle(window.location.hostname.split('.')[0]);
  })}

  ngOnInit() {
    AOS.init();
  }
}
